@if (isVisible()) {
  <div class="connection-warning" [class.offline]="status() === 'offline'" [class.slow]="status() === 'slow'">
    <i class="material-symbols-outlined">{{ iconName() }}</i>
    <span>{{ messageKey() | translate }}</span>
  </div>
}
